import * as React from 'react';
import * as styles from './styles.css';
import { mergeStyles } from '@cian/utils';
import { getCurrencySign } from '../../utils/history-builder';
import { IncDec } from '../IncDec';
export function PriceHistory(props) {
  return React.createElement("div", {
    className: styles['history-wrapper'],
    onScroll: props.onScroll
  }, React.createElement("table", {
    className: styles['history']
  }, React.createElement("tbody", null, props.events.reverse().map(function (event, index) {
    return React.createElement("tr", {
      key: index,
      className: styles['history-event']
    }, React.createElement("td", {
      className: styles['event-date']
    }, event.date), React.createElement("td", {
      className: styles['event-price']
    }, event.newPrice, " ", getCurrencySign(event.currency, props.dealType)), React.createElement("td", mergeStyles(styles['event-diff'], event.trend === 'increase' && styles['event-diff-increase'], event.trend === 'decrease' && styles['event-diff-decrease']), React.createElement(IncDec, {
      trend: event.trend
    }), event.diff, // Не выводим знак валюты, если меняется валюта или начальная цена (trend none)
    event.trend !== 'none' ? ' ' + getCurrencySign(event.currency) : ''));
  }))));
}